/**
 * Error404 — Branded 404 Not Found page (#2454)
 *
 * Deliberately has NO dependency on ConfigProvider / AuthProvider /
 * BrandProvider — this page must render even when the backend is down or
 * the SPA boot failed. All styling uses CSS custom properties defined in
 * brand.css (loaded by main.tsx via index.css import, which is just a
 * link-tag insertion — no JS fetch needed).
 */

import { PAGE_CSS, Logo, ErrorCard } from "./shared";

export function Error404() {
  return (
    <>
      <style>{PAGE_CSS}</style>
      <div className="err-page">
        <ErrorCard
          code="404"
          title="Page not found"
          message="The page you're looking for doesn't exist or has been moved."
          accentVar="--brand-status-info"
          accentBg="var(--brand-status-info-bg)"
          accentBorder="rgba(66,165,245,0.25)"
        >
          <Logo />
        </ErrorCard>
      </div>
    </>
  );
}
